<template>
  <div>
    <input-multiselect
      v-model="model"
      :options="papeis"
      label="Papéis"
      :required="!nomeConjuge"
      :disabled="!!nomeConjuge"
    />
  </div>
</template>
<script>
export default {
  props: {
    codigoProposta: String,
    value: [],
    assinante: Object,
    nomeConjuge: String,
    cliente: Object
  },
  data () {
    return {
      listBase: []
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    papeis: {
      get () {
        return this.$param.EST_PAPEIS.map(el => {
          const tipo = this.$api.UI.Format.SomenteNumeros(this.cliente.DocumentoFederal).length === 11 ? 'pf' : 'pj'
          if (el[tipo]) {
            return {
              text: el.tipo === this.$aux.PapelAssinaturaEnum.Avalista ? 'AVALISTA' : el.papel.replace('@EMITENTENOME', this.cliente?.Nome).replace('@REPRESENTANTEDOCUMENTO', this.cliente?.DocumentoFederal),
              value: { Descricao: el.papel.replace('@EMITENTENOME', this.cliente?.Nome).replace('@REPRESENTANTEDOCUMENTO', this.cliente?.DocumentoFederal), PapelID: el.tipo },
            }
          }
        })
      },
      set () {
        return this.$param.EST_PAPEIS;
      }
    },
  },
  methods: {
    async submit () {
      const th = this;
      const nomeConjuge = th.nomeConjuge
      const assinante = th.assinante

      let arrayInclusao = Array.isArray(th.model) ? [...th.model] : [];
      const arrayExclusao = Array.isArray(th.listBase) ? [...th.listBase] : [];

      if (arrayExclusao.length > 0) {
        await th.removerAssinantes();
      }

      if (arrayInclusao.length > 0) {
        th.$api.Multiplo.Post('FindRecordProdutoRede').then(function (res) {
          arrayInclusao = arrayInclusao.map(papel => {
            return {
              CodigoProposta: th.codigoProposta,
              Nome: nomeConjuge ? `${assinante.Nome} - CÔNJUGE DE ${nomeConjuge}` : assinante.Nome,
              Email: assinante.Email,
              Documento: assinante.DocumentoFederal,
              TelefoneCelular: assinante.TelefoneCelular,
              Descricao: papel?.Descricao,
              PapelID: papel.PapelID === th.$aux.PapelAssinaturaEnum.Avalista ? papel.PapelID : null,
              NotificarPorEmail: th.$aux.NotificaPorEmail.includes(res.ModeloNotificacaoAssinatura),
              NotificarPorWhatsApp: th.$aux.NotificaPorWhatsApp.includes(res.ModeloNotificacaoAssinatura)
            }
          })
          th.$api.Multiplo.Post('InsertCCBDigitalAssinaturas', { dto: arrayInclusao }).then(resInsert => {
            if (th.$api.UI.PostLoadData(resInsert, true)) { };
          });
        })
      }
    },
    carregarAssinantes () {
      const th = this;
      const dtoAssinantes = {
        parameters: [
          { name: 'CodigoProposta', value: th.codigoProposta },
          { name: 'search', value: '' },
        ],
      };

      th.$api.Multiplo.Post('ListCCBDigitalAssinatura', dtoAssinantes).then(assinantes => {
        if (th.$api.UI.PostLoadData(assinantes)) {
          th.$set(th, 'listBase', assinantes.Data.filter(el => th.$api.UI.Format.SomenteNumeros(el.Documento) === th.$api.UI.Format.SomenteNumeros(th.assinante.DocumentoFederal)));
          th.model = th.listBase.map((item) => {
            const papel = th.papeis.find(papel => papel?.value?.Descricao === item?.Descricao)
            return papel ? papel.value : null
          });
        }
      });
    },
    async removerAssinantes () {
      const th = this;
      th.model = {};

      let arrayExclusao = Array.isArray(th.listBase) ? [...th.listBase] : [];

      arrayExclusao = arrayExclusao.map(papel => {
        return papel.Codigo
      })

      await th.$api.Multiplo.Post('RemoveCCBDigitalAssinaturas', { dto: arrayExclusao });
    }
  },
}
</script>
<style scoped>
</style>
